/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */

/**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */
export function encodeBase64Url(bytes: Uint8Array): string {
	if (bytes.length === 0) {
		return '';
	}

	if (btoa === undefined) {
		return Buffer.from(bytes).toString('base64url');
	} else {
		// Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
		const binaryString = Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');
		return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
	}
}
